import { ChevronLeft, ChevronRight } from 'lucide-react';
import { DateTime } from 'luxon';
import React from 'react';
import { Button, ButtonGroup } from 'react-bootstrap';

interface WeekSelectorProps {
  weekStart: DateTime;
  onWeekChange: (newWeekStart: DateTime) => void;
}

const WeekSelector: React.FC<WeekSelectorProps> = ({
  weekStart,
  onWeekChange,
}) => {
  const formatWeekRange = () => {
    const weekEnd = weekStart.endOf('week');
    const currentWeekStart = DateTime.now().startOf('week');

    if (weekStart.hasSame(currentWeekStart, 'day')) {
      return 'Current Week';
    }

    return `${weekStart.toFormat('MMM d')} - ${weekEnd.toFormat('MMM d, yyyy')}`;
  };

  const handlePrevWeek = () => {
    onWeekChange(weekStart.minus({ weeks: 1 }));
  };

  const handleNextWeek = () => {
    onWeekChange(weekStart.plus({ weeks: 1 }));
  };

  const handleCurrentWeek = () => {
    onWeekChange(DateTime.now().startOf('week'));
  };

  const isCurrentWeek = weekStart.hasSame(
    DateTime.now().startOf('week'),
    'day',
  );

  return (
    <ButtonGroup className="d-flex bg-light rounded-pill">
      <Button
        variant="light"
        className="border-0 rounded-start-pill px-3"
        onClick={handlePrevWeek}
        aria-label="Previous week"
      >
        <ChevronLeft size={20} />
      </Button>
      <Button
        variant={isCurrentWeek ? 'white' : 'light'}
        className="border-0 flex-grow-1"
        onClick={handleCurrentWeek}
      >
        {formatWeekRange()}
      </Button>
      <Button
        variant="light"
        className="border-0 rounded-end-pill px-3"
        onClick={handleNextWeek}
        aria-label="Next week"
      >
        <ChevronRight size={20} />
      </Button>
    </ButtonGroup>
  );
};

export default WeekSelector;
